<div class="manage-zones-container">
  <div class="main">
    <div class="zone-actions-drawer">
      <app-zone-actions-drawer></app-zone-actions-drawer>
    </div>
  </div>
</div>
